// A listening microphone is not evidence that every room sentence answers the
// active task. Preserve that task unless the utterance is directed or grounded.
export function isDirectedTaskAnswer(text, question) {
  const answer = String(text || '').trim();
  const prompt = String(question || '').trim();
  if (!answer || !prompt) return false;
  if (/^(?:hey\s+)?(?:aria|arya|area)[\s,:.!]+/i.test(answer)) return true;
  if (/\b(?:i don't know what you|you're welcome|thanks for watching|subscribe)\b/i.test(answer)) return false;
  if (/^(?:please\s+)?(?:click|select|type|press|scroll|zoom|open|use)\b/i.test(answer)
      && !/["“”]|\b(?:if|when|she says|he says|don't|do not)\b/i.test(answer)
      && answer.split(/\s+/).length <= 40) return true;
  if (/^(?:yes|no|allow|deny|continue|go ahead)[.!]*$/i.test(answer)) {
    return /^(?:may i|can i|should i|do you want)\b|\b(?:permission|allow|confirm)\b/i.test(prompt)
      && !/\b(?:which|what| or )\b/i.test(prompt);
  }
  // A short literal option/name appearing in the actual pending question can
  // answer it. Do not infer an answer from shared common words or a long story.
  const normalized = answer.toLowerCase().replace(/[.!?]+$/g, '').trim();
  const words = normalized.split(/\s+/);
  return words.length <= 5 && normalized.length >= 4
    && !/^(?:this|that|here|there|okay|i think|i don't know)$/.test(normalized)
    && prompt.toLowerCase().includes(normalized);
}
